angular.module('zc').component('zcDashboardReactionChart', {
  templateUrl: '/templates/projects.dashboard/reaction_chart.html',
  bindings: {
    project: '<',
    chart: '<',
  },
  controller: zcDashboardReactionChartController
});

zcDashboardReactionChartController.$inject = [
  '$scope',
  '$translate',
  '$window',
  'ChartV2',
  'lineChartV2Config'
];

function zcDashboardReactionChartController($scope, $translate, $window, ChartV2, lineChartV2Config) {
  const vm = this;

  $scope.$watch('$ctrl.project', project => {
    if(!project || !project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    const reactionCounts = [];
    const reactionCountRatios = [];

    _.each(vm.project.dailyStats, stat => {
      const sessionCount = stat.all_access.session_count || 0;
      const reactionCount = stat.all_campaign.reaction_count || 0;
      const reactionCountRatio = reactionCount / sessionCount * 100;
      const startAtUnixTime = moment(stat.start_at).valueOf();

      reactionCounts.push([
        startAtUnixTime,
        reactionCount,
      ]);

      reactionCountRatios.push([
        startAtUnixTime,
        reactionCountRatio,
      ]);
    });

    const chart = new ChartV2(lineChartV2Config, {
      yAxis: [{
        title: { text: null },
        min: 0,
        labels: {
          formatter: function() {
            return `${$window.Highcharts.numberFormat(this.value, 0)} ${$translate.instant('projectsDashboard.reactionChart.reactionCounts')}`;
          }
        },
      }, {
        opposite: true,
        title: { text: null },
        min: 0,
        labels: {
          formatter: function() {
            return `${$window.Highcharts.numberFormat(this.value, 2)} %`;
          }
        }
      }],
    });

    chart.addSeries({
      type: 'column',
      name: $translate.instant('projectsDashboard.reactionChart.reactionCounts'),
      data: reactionCounts,
      tooltip: {
        valueDecimals: 0,
      },
      yAxis: 0,
    });

    chart.addSeries({
      type: 'line',
      name: $translate.instant('projectsDashboard.reactionChart.reactionCountRatios'),
      data: reactionCountRatios,
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1
      },
      yAxis: 1,
    });

    vm.chartConfig = chart.getConfig();
    _.merge(vm.chartConfig.options, {
      chart: {
        width: vm.chart.chart_width,
        height: vm.chart.chart_height,
      }
    });

  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.dashboard/reaction_chart.controller.js